export enum GatingAccessType {
  public = "public",
  limited = "limited",
}

export interface GatingRuleMetadata {
  accessType: GatingAccessType;
}

export interface GatingMaskInformation {
  permission_mask: number;
  permission_mask_level: number;
}

export interface SignificantGatingMaskInformation {
  permission_mask: number;
  permission_mask_level: number;
  significant_permissions_mask: number;
}

export const defaultGatingMask: GatingMaskInformation = Object.freeze({
  permission_mask: 0,
  permission_mask_level: 0,
});
